import React, { useState, useRef, useEffect } from 'react'
import "./CampModal.css"
import JoditEditor from 'jodit-react';
import axios from 'axios';
import { toast } from 'react-toastify';

const CampThreeFour = ({ subprogramId, setShowCampModal, campClassDetails }) => {
    const token = localStorage.getItem("access_token");
    const editor = useRef(null);
    const [halfDayContent, setHalfDayContent] = useState();
    const [fullDayContent, setFullDayContent] = useState();
    const [campData, setCampData] = useState();
    useEffect(() => {
        getPrefilledHalfFullDayData();
    }, [campClassDetails]);


    const getPrefilledHalfFullDayData = async () => {
        setCampData(()=>({
            subprogramId:subprogramId,
            camp_heading_first:campClassDetails?.camp_heading_first,
            camp_heading_second : campClassDetails?.camp_heading_second,
            camp_heading_third : campClassDetails?.camp_heading_third
        }))
        setHalfDayContent(campClassDetails?.content?.[0]?.first_one);
        setFullDayContent(campClassDetails?.content?.[1]?.second_one);
    }
    const campFullHalfContentHandler = async () => {
        try {
            const postData = {
                subprogramId: subprogramId,
                content: [
                    {
                        first_one: halfDayContent
                    },
                    {
                        second_one: fullDayContent
                    }
                ]
            }
            const response = await axios.post(
                process.env.REACT_APP_BASE_URL + `/admin/create_post_program_name`, postData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`,
                },
            }
            );
            if (response?.status === 200 || response?.status === 201) {
                toast.success(`Program Updated Successfully`);
                setShowCampModal(false);
            }
        } catch (error) {
            toast.error("Something went wrong!");
            setShowCampModal(false);
        }

    }
    const campMetaDataHandler = (e) => {
        const { name, value } = e.target;
        setCampData((prevState) => ({
            ...prevState,
            [name]: value
        }))
    }
    const campMetaDataSubmitHandler = async () => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_BASE_URL + `/admin/edit-sub-program-cms`,
                campData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            )
            if (response?.status === 200 || response?.status === 201){
                toast.success('Camp updated successfully');
                setShowCampModal(false);
            }
        } catch (error) {
            toast.error(`Can't update Camp data`);
            console.error(error);
            setShowCampModal(false);
        }
    }
    return (
        <>
            <div className="fluid_container">

                <div className="meta_data_editing_container"
                    style={{ marginBottom: "50px", }}>
                    <div className="call_editable_container" style={{ marginBottom: "10px", }}>
                        <label>Phone:</label>
                        <input type="text"
                            name='camp_heading_first'
                            className='adminform__input'
                            value={campData?.camp_heading_first}
                            onChange={(e) => campMetaDataHandler(e)}
                        />
                    </div>
                    <div className="call_editable_container" style={{ marginBottom: "10px" }}>
                        <label>Email:</label>
                        <input
                            type="email"
                            name='camp_heading_second'
                            className='adminform__input'
                            value={campData?.camp_heading_second}
                            onChange={(e) => campMetaDataHandler(e)}
                        />
                    </div>
                    <div className="call_editable_container" style={{ marginBottom: "10px" }}>
                        <label>Title:</label>
                        <input type="text"
                            className='adminform__input'
                            name='camp_heading_third'
                            value={campData?.camp_heading_third}
                            onChange={(e) => campMetaDataHandler(e)}
                        />
                    </div>

                    <button
                        className='adminbtn adminbtn-primary camp_btm'
                        onClick={() => campMetaDataSubmitHandler()}
                    >Save</button>

                </div>
                <div className="three_four_half_day_container">
                    <div className="half_day_container" style={{ width: "100%" }}>
                        <h1 className='schedule_day_title_camp'>Half Day Schedule</h1>
                        <JoditEditor
                            ref={editor}
                            value={halfDayContent}
                            onChange={(newContent) => {
                                setHalfDayContent(newContent)
                            }}
                        />
                    </div>
                    <div className="full_day_container" style={{ width: "100%" }}>
                        <h1 className='schedule_day_title_camp'>Full Day Schedule</h1>
                        <JoditEditor
                            ref={editor}
                            value={fullDayContent}
                            onChange={(newContent) => {
                                setFullDayContent(newContent)
                            }}
                        />
                    </div>
                </div>
                <button className='adminbtn adminbtn-primary camp_btm'
                    onClick={() => campFullHalfContentHandler()}
                >Save</button>
            </div>
        </>
    )
}

export default CampThreeFour